import React, { Component } from "react"
import { translate } from "react-translate"
import Icon from "react-icons-kit"
import { home } from "react-icons-kit/icomoon/home"
import { fileText2 as devisIcon } from "react-icons-kit/icomoon/fileText2"
import { person as clientIcon } from "react-icons-kit/ionicons/person"
import { cogOutline as matsIcon } from "react-icons-kit/typicons/cogOutline"
import { ic_keyboard_arrow_down as arrowDown } from "react-icons-kit/md/ic_keyboard_arrow_down"
import { Link } from "react-router-dom"

import "./ProMenu.css"
import { Menu, Dropdown, Image } from "semantic-ui-react"
import MenuItem from "./ProMenuItem"
import _ from "lodash"
import logoMyTravo from "../../../assets/icons/logoMyTravo.1.png"

// MENU ITEMS LIST
// If you want to add a menu to the menu bar, just add it here in this array :
// name:  Menu name,
// icon : Menu icon,
// linkTo : Link to the component
const Menus = [
  {
    name: "value_dropdown_accueil",
    icon: home,
    linkTo: "/mtpro"
  },
  {
    name: "value_dropdown_devis_factures",
    icon: devisIcon,
    linkTo: "/mtpro/devis"
  },
  {
    name: "value_dropdown_client",
    icon: clientIcon,
    linkTo: "/mtpro/clients"
  },
  {
    name: "value_dropdown_materiau_ouvrage",
    icon: matsIcon,
    linkTo: "/mtpro/materiaux"
  }
]

class ProMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  componentWillMount() {
    let { t } = this.props
    var MenusCopy = _.clone(Menus)
    MenusCopy = _.map(MenusCopy, x => {
      return {
        ...x,
        name: t(x.name)
      }
    })

    this.setState({
      Menus: MenusCopy
    })
  }

  handleItemClick = (e, { name }) => this.setState({ activeItem: name })

  render() {
    const { activeItem } = this.state
    let { t } = this.props

    return (
      <Menu id="menumenu">
        <Menu.Item id="">
          <Image src={logoMyTravo} />
          {/* <p> MYTRAVO </p> */}
        </Menu.Item>

        {// Building menu from menu items list
        _.map(this.state.Menus, menu => {
          return (
            <MenuItem
              key={menu.name}
              name={menu.name}
              selected={activeItem === menu.name}
              onSelect={this.handleItemClick}
              icon={menu.icon}
              linkTo={menu.linkTo}
            />
          )
        })}

        <Menu.Item
          id="barre1"
          position="right"
          name="photoUser"
          active={activeItem === "photoUser"}
          onClick={this.handleItemClick}
        >
          <img
            id="photoUser"
            src="https://www.jobanim.com/media/users/avatar/191cd8d15b50459bbe372c985409bb11.jpeg"
            alt="photoUser"
          />
          {t("label_hello")}
          <br />
          {t("label_firstname_lastname")}
        </Menu.Item>
        {/* <Menu.Item
          postion="relative"
          id="barre4"
          name="ArrowDown"
          active={activeItem === "ArrowDown"}
         onClick={this.handleItemClick}
        > */}
        {/* <Icon size={38} id="iconnavbar" icon={arrowDown} /> */}
        <Dropdown
          item
          text="Options"
          postion="relative"
          id="iconnavbar"
          name="ArrowDown"
          active={activeItem === "ArrowDown"}
        >
          <Dropdown.Menu>
            <Link
              to={{
                pathname: "/mtpro/parametre",
                state: { from: this.props.location }
              }}
            >
              <Dropdown.Item id="itemParametre">Paramètre</Dropdown.Item>
            </Link>

            <Dropdown.Item>F.A.Q</Dropdown.Item>
            <Dropdown.Item>Déconnexion</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        {/* </Menu.Item> */}
      </Menu>
    )
  }
}

export default translate("ProMenuComponent")(ProMenu)



// WEBPACK FOOTER //
// ./src/components/Pro/Header/ProMenu.js